import Link from "next/link";
import Image from "next/image";
import React, {useEffect, useState} from 'react';
import {CommonServerSideParams} from '@/app/types/CommonServerSideParams';
import {OnlyBrowserPageProps} from '@/layouts/web/types/OnlyBrowserPageProps';
import {SSGPageProps} from '@/layouts/web/types/SSGPageProps';
import ReactDivWebMain from '@/modules/core/reactDivWeb/components/Web/Main/Main';
import WebLayout from '@/layouts/web/components/WebLayout';
import {
  // getWebLayoutStaticPaths,
  getWebLayoutStaticProps,
} from '@/layouts/web/webLayoutSSG';
// import useCustomer from '@/modules/core/data/hooks/useCustomer';
// import { Customer } from '@/modules/core/data/types/Customer';
import {createLogger} from '@/modules/core/logging/logger';
import {
  GetStaticPaths,
  GetStaticProps, GetStaticPropsResult,
  NextPage,
} from 'next';
import PageHeader from "@/components/centralbrisbanedental/page/Header/Header";


import {StaticPropsInput} from '@/app/types/StaticPropsInput';
import {getDashboardContentEditorLayoutStaticProps} from '@/layouts/dashboard/contentEditor/dashboardContentEditorLayoutSSG';
import {getReactDivApiConfig} from '@/modules/core/reactDivAPI/utils/getApiConfig';
import getSystemShellBySingularAPIID
  from '@/modules/core/reactDivAPI/utils/queries/system/getSystemShellBySingularAPIID';
import getShelledPageBySingularAPIID from '@/modules/core/reactDivAPI/utils/queries/web/getShelledPageBySingularAPIID';
import deepmerge from 'deepmerge';
import getClientProjectContentBySystemShellID
  from '@/modules/core/reactDivAPI/utils/queries/web/getClientProjectContentBySystemShellID';
import getSystemShelledFieldsBySystemShellID
  from '@/modules/core/reactDivAPI/utils/queries/system/getSystemShelledFieldsBySystemShellID';
import Annoucement from "@/components/centralbrisbanedental/Announcement";
import Topbar from "@/components/centralbrisbanedental/Topbar";
import NavBar from "@/components/centralbrisbanedental/NavBar/NavBar";
import Hero from "@/components/centralbrisbanedental/Hero/Hero";
import AppointmentRequestForm
  from "@/components/centralbrisbanedental/userActions/AppointmentRequestForm/AppointmentRequestForm";
import CTABannerStandard from "@/components/centralbrisbanedental/CTABannerStandard/CTABannerStandard";
import CTABannerImageDescriptive
  from "@/components/centralbrisbanedental/CTABannerImageDescriptive/CTABannerImageDescriptive";
import CTABannerSplitTiles from "@/components/centralbrisbanedental/CTABannerSplitTiles/CTABannerSplitTiles";
import TwoColumnContent from "@/components/centralbrisbanedental/TwoColumnContent/TwoColumnContent";
import ContentBackgroundImage from "@/components/centralbrisbanedental/ContentBackgroundImage/ContentBackgroundImage";
import Footer from "@/components/centralbrisbanedental/Footer/Footer";
import FAQ from "@/components/centralbrisbanedental/FAQ/FAQ";


const fileLabel = 'pages/index';
const logger = createLogger({ // eslint-disable-line no-unused-vars,@typescript-eslint/no-unused-vars
  fileLabel,
});


const faqs = [
  {
    question: 'How much does it cost to see the dentist?',
    answer:
      "Central Brisbane Dental is committed to providing patients with the best treatment. We charge what is usual and customary for the service. Our dentists take the time to explain everything to the patient including informing them of the fees before their treatment begins. To receive a reduced price for dental treatment at Central Brisbane Dental, join Smile.com.au for a minimum of 15% off our regular prices. Check out our website for our current promotions.",
  },
  {
    question: 'Can I use my health fund card here?',
    answer:
      'We have a HICAPS terminal that can process most health fund claims for you at the time of the appointment. This means you only need to pay the gap that applies following your treatment. Patients with CBHS and HCF usually have no gap to pay on checkup and clean and certain preventive services as we are a part of the CBHS Choice Network and HCF More for Teeth Program. We are also preferred providers for nib, as well as Australian Unity, health.com.au, AIA Health Insurance, My Own Health Insurance, Healthcare Insurance, Frank Health Insurance, GMHBA and Peoplecare through our association with Smile.com.au so you get the highest health fund rebate when you come see us. For specific information relating to your health fund cover you will need to check your health fund policy or contact your health fund provider. We can provide you with a treatment plan and quote with item numbers and descriptions of treatment.',
  },
  {
    question: 'Are you a preferred provider for any health funds?',
    answer:
      'We are a part of the CBHS Choice Network and HCF More for Teeth Program that allows patients with CBHS and HCF to have dental treatment with usually no gap to pay on checkup and clean and certain preventive services. There is a gap to pay for all other services. We are also a nib First Choice Dentist, as well as preferred providers for Australian Unity, health.com.au, AIA Health Insurance, My Own Health Insurance, Healthcare Insurance, Frank Health Insurance, GMHBA and Peoplecare through our association with Smile.com.au so you get the highest health fund rebate when you come see us. We are not linked with any other health funds, but are more than happy to match prices from another dental practice if their prices are lower than ours.',
  },
  {
    question: 'Is treatment covered under Medicare? / Does the practice bulk bill?',
    answer:
      'Dental treatment at private practices in Australia are generally not covered by Medicare and hence there is no “bulk bill” option. Patients have to pay for treatment themselves but may purchase health insurance to cover some of the expense. Medicare may cover treatment for select groups of patients at certain times. The Department of Veterans’ Affairs (DVA) covers the dental treatment of eligible Veterans. The Child Dental Benefit Schedule is a program for eligible children aged 2-17 years that provides up to $1000 in benefits to the child for basic dental services. The government would have sent you a letter if your child is eligible. We are happy to accept these patients.',
  },
  {
    question: 'I have a toothache – can you squeeze me in?',
    answer:
      'We deliberately leave appointment spots available for dental emergencies every day. This allows us the time to not only see you for a consultation but start the treatment to get you out of pain straight away if you want to.',
  },
  {
    question: 'Do you extract wisdom teeth?',
    answer:
      'We can extract most wisdom teeth under local anaesthetic with the option of Penthrox gas sedation as well. To limit side effects and complications, we carefully assess in the mouth and on x-rays the difficulty of each extraction and the closeness of the teeth to vital structures such as the sinuses in the cheeks and the large nerves in the lower jaw. If we determine your case is very complex or requires general aesthesia, we can refer you to a recommended oral surgeon.',
  },
  {
    question: 'I am scared of the dentist – do you have anything to help me?',
    answer:
      'We go to great lengths to ensure that every visit you have with us will be as pleasant and pain free as possible. The dental team prides themselves in their friendly and caring approach, taking the time to explain everything so the patient understands what will happen so they can rest assured. A projector is set up so the patient can relax and watch their favourite DVD while treatment is provided.  Penthrox sedation is available for those who are very nervous.',
  },
  {
    question: 'How do you sterilise your instruments between patients?',
    answer:
      'Central Brisbane Dental adheres strictly to the Australian Dental Association guidelines for infection control. All instruments used on a patient are washed in a special ultrasonic bath as well as manually scrubbed before being sterilised in an autoclave at high temperatures and pressure. We also have strict protocols for surgery cleaning, including purging and testing of water lines that feed the dental chair to ensure optimal water quality delivered through the handpieces.',
  },
  {
    question: 'Why should I come to the dentist every 6 months even if I don’t have any problems?',
    answer:
      'A check-up every 6 months is recommended to detect problems at an early stage and intervene if necessary before a small issue becomes a big one. Tooth decay or gum and bone loss due to gum disease may only cause sensitivity or pain when it is quite advanced and sometimes need to be treated with more complex treatments like root canal and surgery instead of simple fillings and cleaning available in the early stages of the diseases. It is also important to have tartar professionally cleaned from the teeth and gums every 6 months to maintain good oral health. Even those who brush, floss and rinse, leave tartar under the gumline and between teeth where it is hard to detect.',
  },
  {
    question: 'Why do I need x-rays taken?',
    answer:
      'X-rays allow the dentist to see areas we cannot normally see with the naked eye such as between the teeth and under the gums. They are important for diagnosing decay, gum disease and other problems inside the teeth or jaw bone. A good example is to check how close a developing wisdom tooth is to the large nerve in the lower jaw before an extraction to reduce risk of nerve issues. Central Brisbane Dental uses a digital x-ray system to reduce radiation to a minimum. X-rays are usually only taken every 2 years at the check-up appointment so no potential problems are missed unless they are necessary for a specific problem.',
  },
]

/**
 * Only executed on the server side at build time.
 * Necessary when a page has dynamic routes and uses "getStaticProps".
 */
// export const getStaticPaths: GetStaticPaths<CommonServerSideParams> = getPublicLayoutStaticPaths({fallback:true});
// export const getStaticPaths: GetStaticPaths<CommonServerSideParams> = getPublicLayoutStaticPaths();

/**
 * Only executed on the server side at build time.
 *
 * @return Props (as "SSGPageProps") that will be passed to the Page component, as props.
 *
 * @see https://github.com/vercel/next.js/discussions/10949#discussioncomment-6884
 * @see https://nextjs.org/docs/basic-features/data-fetching#getstaticprops-static-generation
 */
export const getStaticProps: GetStaticProps<SSGPageProps, CommonServerSideParams> = async (props: StaticPropsInput): Promise<GetStaticPropsResult<SSGPageProps>> => {
  const commonStaticProps: GetStaticPropsResult<SSGPageProps> = await getWebLayoutStaticProps()(props);
  if (process.env.NEXT_PUBLIC_APP_STAGE !== 'production') {
    logger.info('getStaticProps commonStaticProps', commonStaticProps); // eslint-disable-line no-console
  }

  if ('props' in commonStaticProps) {
    const config = getReactDivApiConfig();

    const [
      // Below is Web Module
      // currentShelledPage,
      // currentClientProjectSEOSettings,
      // currentShelledPageSeoSettings, // NOTE This is a dependency, should loop through these
      // currentClientProjectSEOSettings,
      // Above is Web Module
    ] = await Promise.all([
      // Below is Web Module
      // getShelledPageBySingularAPIID({config, slug: 'home'}),
      // getSystemShelledFieldsBySystemShellID({config, systemShellID: '630f756db23725aedbc16e7d'}),
      // getClientProjectContentBySystemShellID({
      //   config,
      //   clientID: commonStaticProps.props.reactDivClientID,
      //   projectID: commonStaticProps.props.reactDivClientProjectID,
      //   systemShellID: '630f756db23725aedbc16e7d',
      // }),
      // getBySingularAPIID({config, slug: "home"}),
      // Above is Web Module
    ]);

    return deepmerge(commonStaticProps, {
      props: {
        // Below is Web Module
        // currentShelledPage,
        // currentShelledPageSeoSettings,
        // currentClientProjectSEOSettings,
        // Above is Web Module
        builtAt: new Date().toISOString(),
      },
      // revalidate: regenerationDelay,
    });
    // return commonStaticProps;
  } else {
    return commonStaticProps;
  }

};
/**
 * SSG pages are first rendered by the server (during static bundling).
 * Then, they're rendered by the client, and gain additional props (defined in OnlyBrowserPageProps).
 * Because this last case is the most common (server bundle only happens during development stage), we consider it a default.
 * To represent this behaviour, we use the native Partial TS keyword to make all OnlyBrowserPageProps optional.
 *
 * Beware props in OnlyBrowserPageProps are not available on the server.
 */
type Props = {} & SSGPageProps<Partial<OnlyBrowserPageProps>>;

/**
 * Example of a public page.
 */
const Index: NextPage<Props> = (props): JSX.Element => {
  if (process.env.NEXT_PUBLIC_APP_STAGE !== 'production') {
    logger.info('Index props', props); // eslint-disable-line no-console
  }
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY)
    };

    handleScroll();

    window.addEventListener("scroll", handleScroll);
    return () => {;
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])

  return (
    <>
      <div className="sticky top-0 z-10 shadow-md">
        <Annoucement
          mobilePrimaryTextValue="Extracted publication of ClearPath Orthocare case study by Dr Vincent Wan."
          desktopPrimaryTextValue="Extracted publication of ClearPath Orthocare case study by Dr Vincent Wan."
          tailwindWrapperClassNames={{
            tailwind: "bg-[#400068]"
          }}
          tailwindContainerClassNames={{
            tailwind: "mx-auto max-w-7xl py-3 px-3 sm:px-6 lg:px-8 flex flex-wrap items-center justify-between"
          }}
          destination="/static/pdf/case-study-dr-wan.pdf"
        />
        <Topbar
          scrollY={scrollY}
          style={{
            background: "bg-[#f3f3f3]"
          }}
        />
      </div>
      <NavBar />
      <PageHeader
        title="FAQs"
        background="bg-[#400068]"
        backgroundImage="/static/images/headers/life-cycle-header-overlay.png"
      />
      <main>
        <>
          <div className="bg-white">
            <div className="container mx-auto py-12 px-6">
              <div className="lg:grid lg:grid-cols-3 lg:gap-8">
                <div>
                  <h2 className="text-3xl font-extrabold text-black">Frequently asked questions</h2>
                  <p className="mt-4 text-lg text-gray-900">
                    Can’t find the answer you’re looking for? Reach out to our{' '}
                    <Link href="/contact">
                      <a className="font-medium text-indigo-600 hover:text-[#17aaab]">
                        customer support
                      </a>
                    </Link>{' '}
                    team.
                  </p>
                  <Image
                    src={'/static/images/tiles/faqs-battoothyvsriddlertoothy.png.webp'}
                    width="440px"
                    height="304px"
                  />
                </div>
                <div className="mt-12 lg:mt-0 lg:col-span-2">
                  <dl className="space-y-12">
                    <FAQ
                      enableHeading={false}
                      faqs={[
                        {
                          question: "How much does it cost to see the dentist?",
                          answer: "Central Brisbane Dental is committed to providing patients with the best treatment. We charge what is usual and customary for the service. Our dentists take the time to explain everything to the patient including informing them of the fees before their treatment begins. To receive a reduced price for dental treatment at Central Brisbane Dental, join Smile.com.au for a minimum of 15% off our regular prices. Check out our website for our current promotions."
                        },
                        {
                          question: "Can I use my health fund card here?",
                          answer: "We have a HICAPS terminal that can process most health fund claims for you at the time of the appointment. This means you only need to pay the gap that applies following your treatment. Patients with CBHS and HCF usually have no gap to pay on checkup and clean and certain preventive services as we are a part of the CBHS Choice Network and HCF More for Teeth Program. We are also preferred providers for nib, as well as Australian Unity, health.com.au, AIA Health Insurance, My Own Health Insurance, Healthcare Insurance, Frank Health Insurance, GMHBA and Peoplecare through our association with Smile.com.au so you get the highest health fund rebate when you come see us. For specific information relating to your health fund cover you will need to check your health fund policy or contact your health fund provider. We can provide you with a treatment plan and quote with item numbers and descriptions of treatment."
                        },
                        {
                          question: "Are you a preferred provider for any health funds?",
                          answer: "We are a part of the CBHS Choice Network and HCF More for Teeth Program that allows patients with CBHS and HCF to have dental treatment with usually no gap to pay on checkup and clean and certain preventive services. There is a gap to pay for all other services. We are also a nib First Choice Dentist, as well as preferred providers for Australian Unity, health.com.au, AIA Health Insurance, My Own Health Insurance, Healthcare Insurance, Frank Health Insurance, GMHBA and Peoplecare through our association with Smile.com.au so you get the highest health fund rebate when you come see us. We are not linked with any other health funds, but are more than happy to match prices from another dental practice if their prices are lower than ours."
                        },
                        {
                          question: "Is treatment covered under Medicare? / Does the practice bulk bill?",
                          answer: "Dental treatment at private practices in Australia are generally not covered by Medicare and hence there is no “bulk bill” option. Patients have to pay for treatment themselves but may purchase health insurance to cover some of the expense. Medicare may cover treatment for select groups of patients at certain times. The Department of Veterans’ Affairs (DVA) covers the dental treatment of eligible Veterans. The Child Dental Benefit Schedule is a program for eligible children aged 2-17 years that provides up to $1000 in benefits to the child for basic dental services. The government would have sent you a letter if your child is eligible. We are happy to accept these patients."
                        },
                        {
                          question: "I have a toothache – can you squeeze me in?",
                          answer: "We deliberately leave appointment spots available for dental emergencies every day. This allows us the time to not only see you for a consultation but start the treatment to get you out of pain straight away if you want to."
                        },
                        {
                          question: "Do you extract wisdom teeth?",
                          answer: "We can extract most wisdom teeth under local anaesthetic with the option of Penthrox gas sedation as well. To limit side effects and complications, we carefully assess in the mouth and on x-rays the difficulty of each extraction and the closeness of the teeth to vital structures such as the sinuses in the cheeks and the large nerves in the lower jaw. If we determine your case is very complex or requires general aesthesia, we can refer you to a recommended oral surgeon."
                        },
                        {
                          question: "I am scared of the dentist – do you have anything to help me?",
                          answer: "We go to great lengths to ensure that every visit you have with us will be as pleasant and pain free as possible. The dental team prides themselves in their friendly and caring approach, taking the time to explain everything so the patient understands what will happen so they can rest assured. A projector is set up so the patient can relax and watch their favourite DVD while treatment is provided. Penthrox sedation is available for those who are very nervous."
                        },
                        {
                          question: "How do you sterilise your instruments between patients?",
                          answer: "Central Brisbane Dental adheres strictly to the Australian Dental Association guidelines for infection control. All instruments used on a patient are washed in a special ultrasonic bath as well as manually scrubbed before being sterilised in an autoclave at high temperatures and pressure. We also have strict protocols for surgery cleaning, including purging and testing of water lines that feed the dental chair to ensure optimal water quality delivered through the handpieces."
                        },
                        {
                          question: "Why should I come to the dentist every 6 months even if I don’t have any problems?",
                          answer: "A check-up every 6 months is recommended to detect problems at an early stage and intervene if necessary before a small issue becomes a big one. Tooth decay or gum and bone loss due to gum disease may only cause sensitivity or pain when it is quite advanced and sometimes need to be treated with more complex treatments like root canal and surgery instead of simple fillings and cleaning available in the early stages of the diseases. It is also important to have tartar professionally cleaned from the teeth and gums every 6 months to maintain good oral health. Even those who brush, floss and rinse, leave tartar under the gumline and between teeth where it is hard to detect."
                        },
                        {
                          question: "Why do I need x-rays taken?",
                          answer: "X-rays allow the dentist to see areas we cannot normally see with the naked eye such as between the teeth and under the gums. They are important for diagnosing decay, gum disease and other problems inside the teeth or jaw bone. A good example is to check how close a developing wisdom tooth is to the large nerve in the lower jaw before an extraction to reduce risk of nerve issues. Central Brisbane Dental uses a digital x-ray system to reduce radiation to a minimum. X-rays are usually only taken every 2 years at the check-up appointment so no potential problems are missed unless they are necessary for a specific problem."
                        }
                      ]}
                    />

                    {/*{faqs.map((faq) => (*/}
                    {/*  <div key={faq.question}>*/}
                    {/*    <dt className="text-lg leading-6 font-medium text-black">{faq.question}</dt>*/}
                    {/*    <dd className="mt-2 text-base text-gray-900">*/}
                    {/*      {faq.answer}*/}
                    {/*    </dd>*/}
                    {/*  </div>*/}
                    {/*))}*/}
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </>
        <CTABannerImageDescriptive
          imageProperties={{
            layout: 'intrinsic',
            alt: 'happy toothy character',
            type: 'dimensions',
            src: '/static/images/tiles/sunbaking-toothy-teeth-whitening.png.webp',
            height: 285,
            width: 412.5,
          }}
          title="Philips Zoom"
          heading="Teeth Whitening for just $660!"
          description="Come in for a free consultation."
          buttonText="View terms and conditions"
          buttonDestination="/static/pdf/promotion-terms-and-conditions.pdf"
          imageClasses={{
            textAlign: "center",
            padding: "p-5"
          }}
          titleClasses={{
            dynamicColour: '#ff6600',
            fontSize: 'text-base',
            fontWeight: 'semibold',
            letterSpacing: 'tracking-wider',
            uppercase: true,
          }}
          headingClasses={{
            margin: 'mt-2',
            fontSize: 'text-2xl sm:text-3xl',
            fontWeight: 'extrabold',
            letterSpacing: 'tracking-tight',
            colour: 'text-white',
          }}
          descriptionClasses={{
            margin: 'mt-3',
            fontSize: 'text-lg',
            colour: 'text-white'
          }}
          buttonClasses={{
            border: 'border border-transparent rounded-md',
            display: 'inline-flex',
            padding: 'px-5 py-3',
            dynamicBackground: '#17aaab',
            fontSize: 'text-base',
            fontWeight: 'medium',
            colour: 'text-black',
          }}
          classes={{
            position: 'relative',
            dynamicBackground: '#070707',
          }}
        />
        <CTABannerSplitTiles
          dentist="vincent"
          heading="Did you know?"
          value="You can get 2 checkup and cleans a year for $0 or a very small out-of-pocket when you come and see us and use your health fund."
          buttonText="View terms and conditions"
          buttonDestination="/static/pdf/promotion-terms-and-conditions.pdf"
          hasInset={true}
          insetClasses={{
            display: 'hidden lg:block',
            position: 'absolute top-0 inset-x-0',
            height: 'h-1/2',
            dynamicBackground: '#ff6600'
          }}
          buttonClasses={{
            border: 'border border-transparent rounded-md',
            display: 'inline-flex',
            padding: 'px-5 py-3',
            dynamicBackground: '#17aaab',
            fontSize: 'text-base',
            fontWeight: 'medium',
            colour: 'text-black',
          }}
          classes={{
            position: 'relative',
            dynamicBackground: '#fff',
            padding: 'py-16'
          }}
        />
      </main>
      <Footer />
    </>
  );
};

export default Index;
